<div class='tenants-component' style='height: 100%'>

  <div style="margin-left: 10px;">

    <div style="margin-left: -4px; margin-top: 8px">
      <button mat-raised-button
              style="margin-left: 10px; margin-top: 8px"
              type="button"
              [routerLink]="['/tenants/updateControls']">
        Update Controls
      </button>

      <button mat-raised-button
              style="margin-left: 10px; margin-top: 8px"
              type="button"
              (click)="onSendNotifications()">
        Send E-mail notifications
      </button>
    </div>
  </div>

  <div style="margin-top: 10px;">
    <p-table [value]="tenants"
                 [rows]="20"
                 [paginator]="true"
                 [pageLinks]="3"
                 [rowsPerPageOptions]="[10, 20, 50]"
                 #table
    dataKey="tenantId"
    >

      <ng-template pTemplate="header">
        <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
          <th *ngFor="let col of cols" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon *ngIf="col.field == 'name'" [field]="col.field" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
          <th>Lead Expert</th>
          <th>Package</th>
          <th>Size</th>
          <th></th>
        </tr>
        <tr>
          <th *ngFor="let col of cols" [ngSwitch]="col.field">
            <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                   (input)="table.filter($event.target['value'], col.field, 'contains')">
            <span *ngSwitchCase="'date'"></span>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
        <tr [ngStyle]="{'color': item.isDisabled ? 'gray' : 'black'}">
          <td>{{item.tenantId}}</td>
          <td>{{item.users?.length}}</td>
          <td>{{item.databaseName}}</td>
          <td>{{item.creationDate | date:'shortDate'}}</td>
          <td><div>
            <div>{{getConsultantCompanyName(item)}}</div>
            <div>{{getConsultantCompanyAddress(item)}}</div>
          </div></td>
          <td>{{getConsultantManagerEmail(item)}}</td>
          <td><div>
            <div>{{getClientCompanyName(item)}}</div>
            <div>{{getClientCompanyAddress(item)}}</div>
          </div></td>
          <td>{{getClientManagerEmail(item)}}</td>
          <td><input type="checkbox" [checked]="item.canCreateComplianceArea"
                     (change)="setCanCreateComplianceArea(item.tenantId, $event.target['checked'])"/></td>
          <td><input type="checkbox" [checked]="item.canCreatePartnerProjects"
                     (change)="setCanCreatePartnerProjects(item.tenantId, $event.target['checked'])"/></td>
          <td><div *ngFor="let u of item.lastLoggedInUsers">{{u.firstName}} {{u.lastName}} {{u.emailAddress}} - {{u.lastLoginTime | date :"M/d/y h:mm a"}}</div></td>
          <td>{{item.advisor}}</td>
          <td>{{item.moAdvisory}}</td>
          <td>{{formatBytes(item.spaceUsed, 2)}}</td>
          <td><button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="editTenant(item.tenantId)"
                      icon="pi pi-pencil">
          </button>
            <button type="button"
                    pButton
                    class="risksponge-button"
                    (click)="deleteTenant(item.tenantId)"
                    icon="pi pi-trash">
            </button>
            <button *ngIf="!item.isInitialized"
                    type="button"
                    pButton
                    class="risksponge-button"
                    (click)="initializeTenant(item)"
                    icon="pi pi-thumbs-up">
            </button>
            <button *ngIf="item.isDisabled"
                    type="button"
                    pButton
                    class="risksponge-button"
                    (click)="enableTenant(item.tenantId)"
                    icon="pi pi-reply">
            </button>
          </td>
        </tr>
      </ng-template>


    </p-table>
  </div>

  <div *ngIf="msg" role="alert" class="alert alert-info alert-dismissible">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span>
    </button>
    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
    <span class="sr-only">Error:</span>
    {{msg}}
  </div>
</div>
